import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DevBreakpointBadgeComponent } from './components/dev-breakpoint-badge/dev-breakpoint-badge.component';

@Component({
  selector: 'fu-root',
  templateUrl: './app.component.html',
  styleUrls: [
    './app.component.scss',
    '../styles.scss',
    '../typography.scss',
    '../controls.scss',
    '../form.scss',
    '../../../../node_modules/vanilla-cookieconsent/dist/cookieconsent.css',
    '../cookie-consent.overrides.scss',
    '../global.scss',
  ],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation -- hosts the global stylesheets, which must not be scoped
  encapsulation: ViewEncapsulation.None,
  imports: [RouterOutlet, DevBreakpointBadgeComponent],
})
export class AppComponent {}
